var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWalletConnect = function SvgWalletConnect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0867 11.864C19.1729 8.04535 12.8272 8.04535 8.91331 11.864L8.3963 12.3684C8.20061 12.5593 8.20061 12.8689 8.3963 13.0598L10.0076 14.6319C10.1055 14.7274 10.2641 14.7274 10.362 14.6319L11.0562 13.9546C13.7866 11.2907 18.2135 11.2907 20.9439 13.9546L21.5921 14.5871C21.69 14.6825 21.8486 14.6825 21.9464 14.5871L23.5578 13.015C23.7535 12.824 23.7535 12.5145 23.5578 12.3235L23.0867 11.864ZM27.8532 16.5144L26.4191 15.1153C26.2234 14.9243 25.9062 14.9243 25.7105 15.1153L21.121 19.593C21.0721 19.6407 20.9927 19.6407 20.9438 19.593L16.3543 15.1152L16.3543 15.1152C16.1586 14.9242 15.8413 14.9242 15.6456 15.1152L11.0563 19.593C11.0073 19.6407 10.928 19.6407 10.8791 19.593L6.28954 15.1152C6.09385 14.9242 5.77656 14.9242 5.58087 15.1152L4.14677 16.5144C3.95108 16.7053 3.95108 17.0149 4.14677 17.2058L10.6134 23.515C10.8091 23.7059 11.1264 23.7059 11.3221 23.515L15.9115 19.0372C15.9604 18.9895 16.0397 18.9895 16.0886 19.0372L20.6781 23.515C20.8738 23.7059 21.1911 23.7059 21.3868 23.515L27.8532 17.2059C28.0489 17.0149 28.0489 16.7054 27.8532 16.5144Z",
    fill: "url(#paint0_radial_1852_65455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1852_65455",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4 16.3291) scale(24 14.6582)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
};

export { SvgWalletConnect as ReactComponent };
export default __webpack_public_path__ + "459344f958327f577f66f6d002e3ee49.svg";